module.exports = __webpack_public_path__ + "static/media/polaroid-13.bdf871ea.png";